import { render, staticRenderFns } from "./MobileActiveGarageBlock.vue?vue&type=template&id=0db12e49"
import script from "./MobileActiveGarageBlock.vue?vue&type=script&lang=js"
export * from "./MobileActiveGarageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports